/* eslint-disable no-param-reassign */

/* eslint-disable security/detect-object-injection */
import React, { useCallback, useContext, useMemo, useState } from 'react';
import _ from 'lodash';
import { useModal } from '@jutro/components';
import { wizardProps, WizardPage } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { EntityUtil } from '@xengage/gw-portals-util-js';
import { Address, AddressComponent } from 'premier-capability-policyjob-react';
import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import { PremierConstants } from 'premier-constant-service';
import useAccordionStates from '../../hooks/useAccordionStates';
import presentationMetadata from './LocationsPage.metadata.json5';
import messages from './LocationsPage.messages';
import styles from './LocationsPage.module.scss';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';


function LocationsPage(props) {
    const { showConfirm, showAlert } = useModal();
    const breakpoint = useContext(BreakpointTrackerContext);
    const {
        wizardData, updateWizardData, currentStep, viewModelService, steps
    } = props;
    const [showErrors, setShowErrors] = useState(false);
    const { updateSubmission, saveAndQuoteSubmissionService } = useUpdateSubmissionServices();
    const {
        pageKey
    } = currentStep;
    const metadata = presentationMetadata[pageKey];
    const { isComponentValid, initialValidation, onValidate, disregardFieldValidation } = useValidation('LocationsPage');
    const jobNumber = wizardData.value?.quoteID || wizardData.value?.jobID;
    const { lineName } = PremierConstants;
    const productCode = _.get(wizardData.value, 'baseData.productCode');
    const lobLineName = productCode ? lineName[productCode] : '';
    const actLocFieldLine = ['spaAndWellLine', 'eveLiaLine', 'spoAndRecLine']
    // Only one location can be set as Primary Location

    const deleteLocation = useCallback(
        ({ iterableIndex }) => {
            showConfirm({
                title: messages.removeLocationTitle,
                message: messages.removeLocationDescription,
                status: 'warning',
                icon: 'mi-error-outline'
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }

                    const locationListPath = 'baseData.policyLocations_Ext.value';
                    const locationList = _.get(wizardData, locationListPath);
                    const location = locationList[iterableIndex];

                    const newLocationList = _.remove(locationList,
                        (locationFromList) => _.isEqual(locationFromList, location));

                    _.set(wizardData, newLocationList, locationListPath);
                    disregardFieldValidation(`addressDetails${iterableIndex}`);
                    updateWizardData(wizardData);

                    return true;
                }, _.noop
            );
        },
        [showConfirm, wizardData, disregardFieldValidation, updateWizardData]
    );

    const onNext = useCallback(
        async () => {
            _.set(wizardData.value, `lobData.${lobLineName}.preQualQuestionSets_Ext[0].answers.JurisdictionQues`, wizardData.value.baseData.policyLocations_Ext[0].address.state);

            if(lobLineName === 'envLin') {
                const locRisks = _.get(wizardData.value, `lobData.${lobLineName}.coverables.locRisks`);

                if (!_.isUndefined(locRisks)) {

                    _.each(locRisks, (locRisk) => {
                        if (!_.isUndefined(locRisk)) {
                            const plyLctR = _.filter(wizardData.value.baseData.policyLocations_Ext, (plyLct) => plyLct.accountLocPublicID === locRisk.coveredLocations.actAdrsPublicID)[0];

                            if (!_.isUndefined(plyLctR) && !_.isUndefined(locRisk.coveredLocations) && locRisk.coveredLocations.accountAddressOfLocRisk !== undefined) {
                                locRisk.coveredLocations.accountAddressOfLocRisk.country = plyLctR.address.country
                                locRisk.coveredLocations.accountAddressOfLocRisk.addressLine1 = plyLctR.address.addressLine1
                                locRisk.coveredLocations.accountAddressOfLocRisk.addressLine2 = plyLctR.address.addressLine2
                                locRisk.coveredLocations.accountAddressOfLocRisk.addressLine3 = plyLctR.address.addressLine3
                                locRisk.coveredLocations.accountAddressOfLocRisk.city = plyLctR.address.city
                                locRisk.coveredLocations.accountAddressOfLocRisk.state = plyLctR.address.state
                                locRisk.coveredLocations.accountAddressOfLocRisk.postalCode = plyLctR.address.postalCode
                            }
                        }
                    });

                    const storageTankLocRisks = _.get(wizardData.value, `lobData.${lobLineName}.coverables.envImpairmentCoverable.storageTanks.storageTanksInformation`);
                    
                    _.each(storageTankLocRisks, (storageTankLocRisk) => {
                        if (!_.isUndefined(storageTankLocRisk) && !_.isUndefined(storageTankLocRisk.accountAddressOfLocRisk)) {
                            const plyLctR = _.filter(wizardData.value.baseData.policyLocations_Ext, (plyLct) => plyLct.accountLocPublicID === storageTankLocRisk.actAdrsPublicID)[0];

                            if (!_.isUndefined(plyLctR)) {
                                storageTankLocRisk.accountAddressOfLocRisk.country = plyLctR.address.country
                                storageTankLocRisk.accountAddressOfLocRisk.addressLine1 = plyLctR.address.addressLine1
                                storageTankLocRisk.accountAddressOfLocRisk.addressLine2 = plyLctR.address.addressLine2
                                storageTankLocRisk.accountAddressOfLocRisk.addressLine3 = plyLctR.address.addressLine3
                                storageTankLocRisk.accountAddressOfLocRisk.city = plyLctR.address.city
                                storageTankLocRisk.accountAddressOfLocRisk.state = plyLctR.address.state
                                storageTankLocRisk.accountAddressOfLocRisk.postalCode = plyLctR.address.postalCode
                            }
                        }
                    });
                }
            } else if (lobLineName !== 'perLine') {
                const locRisks = _.get(wizardData.value, `lobData.${lobLineName}.coverables.locRisks`);

                if (!_.isUndefined(locRisks)) {

                    _.each(locRisks, (locRisk) => {
                        if (!_.isUndefined(locRisk)) {
                            const plyLctR = _.filter(wizardData.value.baseData.policyLocations_Ext, (plyLct) => plyLct.accountLocPublicID === locRisk.actAdrsPublicID)[0];

                            if (!actLocFieldLine.includes(lobLineName) && !_.isUndefined(plyLctR) && locRisk.accountAddressOfLocRisk !== undefined) {
                                locRisk.accountAddressOfLocRisk.country = plyLctR.address.country
                                locRisk.accountAddressOfLocRisk.addressLine1 = plyLctR.address.addressLine1
                                locRisk.accountAddressOfLocRisk.addressLine2 = plyLctR.address.addressLine2
                                locRisk.accountAddressOfLocRisk.addressLine3 = plyLctR.address.addressLine3
                                locRisk.accountAddressOfLocRisk.city = plyLctR.address.city
                                locRisk.accountAddressOfLocRisk.state = plyLctR.address.state
                                locRisk.accountAddressOfLocRisk.postalCode = plyLctR.address.postalCode
                            } else if(actLocFieldLine.includes(lobLineName) && !_.isUndefined(plyLctR)) {
                                locRisk.accountLocFie.country = plyLctR.address.country
                                locRisk.accountLocFie.addressLine1 = plyLctR.address.addressLine1
                                locRisk.accountLocFie.addressLine2 = plyLctR.address.addressLine2
                                locRisk.accountLocFie.addressLine3 = plyLctR.address.addressLine3
                                locRisk.accountLocFie.city = plyLctR.address.city
                                locRisk.accountLocFie.state = plyLctR.address.state
                                locRisk.accountLocFie.postalCode = plyLctR.address.postalCode
                            }
                        }
                    });
                }
            } else {
                const coverables = _.get(wizardData.value, `lobData.${lobLineName}.coverables`);
                const offeringCode = _.get(wizardData.value, `lobData.${lobLineName}.selectedOffering_Ext`);
                let locRisks

                if (offeringCode === "TinHom") {
                    locRisks = coverables.tinyHomesCoverable.tinyHomes
                } else if (offeringCode === "Cond") {
                    locRisks = coverables.condoCoverable.condominiums
                } else if (offeringCode === "RisAssDwe") {
                    locRisks = coverables.riskAssistDwellingsCoverable.riskAssistDwellings
                } else if (offeringCode === "MobHom") {
                    locRisks = coverables.mobileHomeCoverable.mobileHomes
                }

                if (!_.isUndefined(locRisks)) {

                    _.each(locRisks, (locRisk) => {
                        if (!_.isUndefined(locRisk)) {
                            const plyLctR = _.filter(wizardData.value.baseData.policyLocations_Ext, (plyLct) => plyLct.accountLocPublicID === locRisk.propertyDetails.accountLocFie.publicID)[0];

                            locRisk.propertyDetails.accountLocFie.country = plyLctR.address.country
                            locRisk.propertyDetails.accountLocFie.addressLine1 = plyLctR.address.addressLine1
                            locRisk.propertyDetails.accountLocFie.addressLine2 = plyLctR.address.addressLine2
                            locRisk.propertyDetails.accountLocFie.addressLine3 = plyLctR.address.addressLine3
                            locRisk.propertyDetails.accountLocFie.city = plyLctR.address.city
                            locRisk.propertyDetails.accountLocFie.state = plyLctR.address.state
                            locRisk.propertyDetails.accountLocFie.postalCode = plyLctR.address.postalCode
                        }
                    });
                } else if (offeringCode === "PerUmbLia") {
                    locRisks = coverables.perUmbLiaCoverable.propertyDetails
                    _.each(locRisks, (locRisk) => {
                        if (!_.isUndefined(locRisk)) {
                            const plyLctR = _.filter(wizardData.value.baseData.policyLocations_Ext, (plyLct) => plyLct.accountLocPublicID === locRisk.accountLocFie.publicID)[0];

                            locRisk.accountLocFie.country = plyLctR.address.country
                            locRisk.accountLocFie.addressLine1 = plyLctR.address.addressLine1
                            locRisk.accountLocFie.addressLine2 = plyLctR.address.addressLine2
                            locRisk.accountLocFie.addressLine3 = plyLctR.address.addressLine3
                            locRisk.accountLocFie.city = plyLctR.address.city
                            locRisk.accountLocFie.state = plyLctR.address.state
                            locRisk.accountLocFie.postalCode = plyLctR.address.postalCode
                        }
                    });
                }
            }


            const { currentStepIndex } = props;
            const newSteps = steps.slice(currentStepIndex + 1, steps.length);

            const { jobType } = wizardData.value.baseData;

            if (wizardData.value.baseData.jobType === 'PolicyChange' && (newSteps.length === 1)) {
                const response = await saveAndQuoteSubmissionService('PRVRecVehLine', 'LocationsPage', jobNumber, wizardData.value, jobType, true);

                wizardData.value = response.quoteResponse;
            } else {
                const response = await updateSubmission('PRVRecVehLine', 'LocationsPage', wizardData);

                wizardData.value = response;
            }


            updateWizardData(wizardData);

            return wizardData;
        },
        [wizardData, lobLineName, props, steps, updateWizardData, saveAndQuoteSubmissionService, jobNumber, updateSubmission]
    );

    const onSave = useCallback(
        async () => {

            if (!wizardData.baseData.policyLocations_Ext.aspects.subtreeValid) {
                setShowErrors(true)

                showAlert({
                    title: 'Missing required field',
                    message: 'All mandatory fields are required to save the data',
                    status: 'error',
                    icon: 'mi-error-outline'
                }).catch(_.noop);

                return false
            }

            const subVMCopy = _.clone(wizardData)

            validationUtil.unSetIsValidationReqFlag(subVMCopy.baseData.policyLocations_Ext.value, ' ')
    
            if (wizardData.value.baseData.jobType === 'PolicyChange') {
                await saveAndQuoteSubmissionService('PRVRecVehLine', 'LocationsPage', jobNumber, subVMCopy.value, jobType, true);
            } else {
                await updateSubmission('PRVRecVehLine', 'LocationsPage', subVMCopy);
            }
                            
            return wizardData;
        },
        [lineName, wizardData, updateSubmission]
    );

    const {
        openAccordions,
        accordionCallbackProps,
        renderKey
    } = useAccordionStates({
        ownerVM: wizardData
    });

    const addNewLocation = useCallback((callbackProps) => {
        const locationObj = {
            isPrimary: false,
            address: new Address(),
            locationNum: EntityUtil.nextId(),
            tempID: EntityUtil.nextId()
        };

        const { _xCenter, _dtoName } = wizardData.baseData.policyLocations_Ext;
        const locationVM = viewModelService.create(locationObj, _xCenter, _dtoName);
        const newSubmissionVM = viewModelService.clone(wizardData);

        _.get(newSubmissionVM, 'baseData.policyLocations_Ext').pushElement(locationVM)

        updateWizardData(newSubmissionVM);
        openAccordions(callbackProps);
    }, [wizardData, updateWizardData, viewModelService, openAccordions]);

    const locationOverrides = useMemo(() => {
        const locationList = _.get(wizardData, 'baseData.policyLocations_Ext', []);
        let overrides = [];

        if (!_.isEmpty(locationList)) {
            overrides = locationList.children.map((location, index) => {
                const locValue = location.value;

                return {
                    [`deleteLocationDetails${index}`]: {
                        disabled: locationList.length === 1 || locValue.isPrimary,
                        visible: false
                    },
                    [`addressDetails${index}`]: {
                        value: location.address,
                        // callAddressValidateService: false
                    },
                    [`isPrimaryLocationField${index}`]: {
                        visible: false
                    }
                };
            });
        }

        return Object.assign({}, ...overrides);
    }, [wizardData]);

    const overrideProps = {
        '@field': {
            // apply to all fields
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        addLocationDetails: {
            disabled: !isComponentValid,
            visible: false
        },
        ...locationOverrides,
        ...accordionCallbackProps()
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            addNewLocation,
            deleteLocation,
            onValidate
        },
        resolveComponentMap: {
            addressComponent: AddressComponent
        },
    };

    const skipOnResumeIf = () => {
        const periodStatus = _.get(wizardData, 'baseData.periodStatus.value.code');

        return (periodStatus === 'Quoted');
    };

    return (
        <WizardPage
            skipWhen={skipOnResumeIf || initialValidation}
            disableNext={!isComponentValid}
            onNext={onNext}
            onSave={onSave}
        >
            <div key={renderKey()}>
                <ViewModelForm
                    uiProps={metadata}
                    model={wizardData}
                    onModelChange={updateWizardData}
                    callbackMap={resolvers.resolveCallbackMap}
                    overrideProps={overrideProps}
                    onValidationChange={onValidate}
                    classNameMap={resolvers.resolveClassNameMap}
                    componentMap={resolvers.resolveComponentMap}
                />
            </div>
        </WizardPage>
    );
}

LocationsPage.propTypes = wizardProps;
export default withViewModelService(LocationsPage);
